module.exports = __webpack_public_path__ + "static/mintzebrahamper-64ff1e98f4dec1909b4c68aa8ca81315.jpeg";